<template>
    <div class="tier" v-if="!loading">
        <!-- <h1>{{ tier.name }}</h1> -->
        <div id="info">
            <!-- <div id="label">
                <div class="clip-text clip-text_one">{{ tier.name }}</div>
            </div> -->
            <div id="philosophy">
                <div class="heading">
                    <h2>Philosophy</h2>
                </div>
                <p>{{ tier.philosophy }}</p>
                <div class="heading">
                    <h2>Flavor</h2>
                </div>
                <p>{{ tier.flavor }}</p>
            </div>
        </div>
        <div id="banlist-frame">
            <div class="heading">
                <h2>Banlist</h2>
            </div>
            <div id="banlist" v-if="!loading && tier.banlist.length > 0">
                <div class="card-stack" v-for="category in banlistByCategory">
                    <h2>{{ category.name }}</h2>
                    <template v-for="card in category.cards" :key="card.name">
                        <div class="card-frame">
                            <div class="card-trigger" @mouseover="cardMouseover" @mouseleave="cardMouseLeave"></div>
                            <img
                                class="card-image"
                                :class="card.slug"
                                :src="card.scryfallSearchBlackBorder.data[0].image_uris.png"
                            />
                        </div>
                    </template>
                </div>
            </div>
            <p v-else>None</p>
        </div>
    </div>
    <LoadingSpinner v-else />
</template>
<script>
import { gql } from 'graphql-request';
import LoadingSpinner from '../components/LoadingSpinner.vue';

export default {
    components: { LoadingSpinner },
    props: ['slug'],
    data() {
        return {
            tier: [],
            loading: true,
            errors: [],
        };
    },
    computed: {
        banlistByCategory() {
            let categories = [];
            if (this.tier && !this.loading) {
                this.tier.banlist.forEach((card) => {
                    if (!categories.includes(card.category)) {
                        categories.push(card.category);
                    }
                });
            }

            let banlist = [];
            categories.forEach((cat) => {
                let name = cat;
                if (name == null) {
                    name = 'Other';
                }
                let category = { name: name };
                category.cards = [];
                this.tier.banlist.forEach((card) => {
                    if (card.category === cat && card.dateRemoved == null) {
                        category.cards.push(card);
                    }
                });
                category.cards.sort(function (card1, card2) {
                    return card1.name < card2.name ? -1 : 1;
                });
                banlist.push(category);
            });

            // Sort the banlist alphabetically by category
            banlist.sort(function (category1, category2) {
                return category1.cards.length < category2.cards.length ? 1 : -1;
            });

            // Find the "General" category in the banlist
            const index = banlist.findIndex((category) => {
                return category.name == 'General';
            });

            // Move the "General" Category to the first position in the array
            Array.prototype.move = function (from, to) {
                this.splice(to, 0, this.splice(from, 1)[0]);
                return this;
            };
            let sortedBanlist = banlist.move(index, 0);

            return sortedBanlist;
        },
    },
    methods: {
        cardMouseover(e) {
            e.target.parentNode.classList.add('card-top');
        },
        cardMouseLeave(e) {
            e.target.parentNode.classList.remove('card-top');
        },
        async fetchTierData(slug) {
            this.loading = true;
            const data = await this.$graphcms.request(
                gql`
                {
                    tiers(where: {slug: "${slug}"}) {
                        philosophy
                        flavor
                        name
                        banlist(first:100) {
                            name
                            dateAdded
                            dateRemoved
                            category
                            slug
                            scryfallSearchBlackBorder {
                                data {
                                    image_uris {
                                        png
                                    }
                                }
                            }
                        }
                    }
                }
            `
            );

            this.errors = data.errors;
            this.loading = false;
            this.tier = data.tiers[0];

            window.document.title = `${this.tier.name} | EDH and Other Bullshit`;
        },
    },
    watch: {
        '$route.params.slug': function (slug) {
            this.fetchTierData(slug);
        },
    },
    async mounted() {
        this.fetchTierData(this.slug);
    },
};
</script>

<style lang="scss">
$sidebar-width: 380px;

$card-width: 196px;
$card-height: 273px;

.heading {
    position: relative;
    width: 300px;
    margin: 4px 0px 6px 0px;

    h2 {
        width: 100%;
        height: 46px;
        color: $color-text-light;
        text-align: center;
        //margin: 8px 0px;
    }

    h2::before {
        width: 100%;
        content: '';
        background-color: $color-primary;
        position: absolute;
        top: 2px;
        left: 0;
        bottom: 12px;
        right: 0;
        z-index: -1;
        transform: rotate(-4deg) skew(-20deg);
    }
}

.tier {
    width: 85%;
    height: 100%;
    margin: 0 auto;
    // padding: 1rem 0 0 0;

    display: flex;
    gap: 1rem;
    // justify-content: space-between;

    @media (min-width: 0px) {
        flex-direction: column;
    }

    @media (min-width: ($sidebar-width + $card-width + 200px)) {
        flex-direction: row;
    }

    #info {
        display: flex;
        flex-direction: column;
        gap: 4px;

        flex: 0 0 $sidebar-width;

        /* Clip text element */
        .clip-text {
            white-space: nowrap;
            font-size: 6rem;
            font-weight: bold;
            line-height: 1;
            position: relative;
            display: inline-block;
            width: $sidebar-width;
            //
            padding: 1.8rem 3rem;
            margin-bottom: 1rem;
            text-align: center;
            /* Color fallback */
            color: #fff;
            background-clip: text;
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;

            -webkit-tap-highlight-color: rgba(255, 255, 255, 0);
            -webkit-user-select: none !important;
            -webkit-touch-callout: none !important;
            user-select: none;

            &:before,
            &:after {
                position: absolute;
                content: '';
            }

            /* Background */
            &:before {
                z-index: -2;
                top: 0;
                right: 0;
                bottom: 0;
                left: 0;
                background-image: inherit;

                border-radius: 50px 0 50px 0;
            }

            /* Text Background (black zone) */
            &:after {
                position: absolute;
                z-index: -1;
                top: 15px;
                right: 15px;
                bottom: 15px;
                left: 15px;
                background-color: $color-background;
                border-radius: 35px 0 35px 0;
            }

            /* Change the background position to display letter when the black zone isn't here */
            &--no-textzone:before {
                background-position: -0.75em 0;
            }

            &--no-textzone:after {
                content: none;
            }

            /* Use Background-size cover for photo background and no-repeat background */
            &--cover,
            &--cover:before {
                background-repeat: no-repeat;
                -webkit-background-size: cover;
                background-size: cover;
                background-position: 50% 50%;
            }

            /* Background image from http://thepatternlibrary.com/ and http://lorempixel.com */
            &_one {
                background-image: url('../assets/img/wallpaper-zendikar-small.png');
            }
        }

        #philosophy {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            text-align: justify;
            padding-top: 1rem;
            //            font-size: 1.1rem;

            // border: solid 2px $color-primary;
            // padding: 1rem;
            // background: $color-primary;
            // color: $color-text-light;

            p {
                margin-bottom: 2rem;
            }
        }
    }

    #banlist-frame {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: flex-start;
        padding-top: 1rem;

        flex: 1;

        @media (min-width: 0px) {
            height: auto;
            overflow: visible;
        }

        @media (min-width: ($sidebar-width + $card-width + 200px)) {
            height: 100%;
            overflow: auto;
        }

        h2 {
            text-align: center;
        }

        .card-image {
            width: $card-width;
            height: $card-height;
            z-index: 0;
            pointer-events: none;
        }

        #banlist {
            // Flexbox
            // display: flex;
            // flex-direction: row;
            // align-items: flex-start;
            // justify-content: center;
            // gap: 1rem;
            // flex-wrap: wrap;

            display: grid;
            gap: 1rem;
            width: 100%;
            grid-template-columns: repeat(auto-fill, $card-width);
            justify-content: center;
            padding-bottom: 50px;
            //

            .card-stack {
                display: inline-block;
                margin-bottom: 243px;

                .card-frame {
                    height: 30px;
                    position: relative;
                    width: 100%;

                    .card-trigger {
                        position: absolute;
                        height: 30px;
                        top: 0;
                        left: 0;
                        width: 100%;
                    }

                    &.card-top {
                        z-index: 1;
                    }
                }
            }
        }

        // #banlist {
        //     display: flex;
        //     flex-direction: row;
        //     align-items: flex-start;
        //     justify-content: flex-start;
        //     // width: 100%;
        //     height: fit-content;
        //     flex: 1;
        //     gap: 1rem;
        //     flex-wrap: wrap;

        //     .card-image {
        //         width: 196px;
        //         // aspect-ratio: auto 196/273;
        //         height: 273px;
        //         // height: fit-content;
        //     }
        // }
    }
}
</style>
